import { useLingui } from "@lingui/react/macro";
import React from "react";
import { ExcursionActivityLevel } from "@silversea-ssc/ui-components-react";
import { useExcursionsMicroContent } from "features/shorex/ExcursionsMicroContentProvider";

type Props = {
  level: number;
};

const ContentExcursionActivityLevel: React.FC<
  React.PropsWithChildren<Props>
> = ({ level }) => {
  const { t } = useLingui();
  const { activityLevels = [] } = useExcursionsMicroContent();
  const { label, iconStep = 0 } =
    activityLevels.find((x) => x?.iconStep == level) || {};

  return (
    <ExcursionActivityLevel
      iconStep={iconStep}
      title={t`Activity Level`}
      label={label?.localized}
    />
  );
};

export default ContentExcursionActivityLevel;
